export function totalOf(records: RecordEntry[]): MoneyAmount {
  return records.reduce((tally: MoneyAmount, record: RecordEntry) => {
    return (tally += record.amount);
  }, 0);
}
